import React from 'react';

import './Skills.css';
import Divider from '../Divider/Divider';

const Skills = () => {
    return (
      <div className="skills_grid_container">
        <h1 class="title" style={{color:'#000000'}}>Technical Stack </h1>  
        <Divider/> 
        <div className='skills_grid'>
        <div className="skills_gird_item"> <img src={require('./img/logo-reactjs.png')} alt="logo"></img><span className="skilltooltip">React </span></div>
        <div className="skills_gird_item">     <img src={require('./img/logo-nextjs.png')} alt="logo"></img><span className="skilltooltip">NextJs </span></div>
        <div className="skills_gird_item">    <img src={require('./img/logo-nodejs.png')} alt="logo"></img><span className="skilltooltip">Nodejs </span></div>
        <div className="skills_gird_item">    <img src={require('./img/logo-js.png')} alt="logo"></img><span className="skilltooltip">JavaScript </span></div>
        <div className="skills_gird_item">    <img src={require('./img/logo-ts.png')} alt="logo"></img><span className="skilltooltip">TypeScript </span></div>
        <div className="skills_gird_item">    <img src={require('./img/logo-java.png')} alt="logo"></img><span className="skilltooltip">Java </span></div>
        <div className="skills_gird_item">    <img src={require('./img/logo-expressjs.png')} alt="logo"></img><span className="skilltooltip">Express </span></div>
        <div className="skills_gird_item">    <img src={require('./img/logo-mongodb.png')} alt="logo"></img><span className="skilltooltip">MongoDB </span></div>
        <div className="skills_gird_item">    <img src={require('./img/logo-firebase.png')} alt="logo"></img><span className="skilltooltip">Firebase </span></div>
        <div className="skills_gird_item">     <img src={require('./img/logo-redux.png')} alt="logo"></img><span className="skilltooltip">Redux </span></div>
        <div className="skills_gird_item">    <img src={require('./img/logo-msql.png')} alt="logo"></img><span className="skilltooltip">MySQL </span></div>
        <div className="skills_gird_item">    <img src={require('./img/logo-graphql.png')} alt="logo"></img><span className="skilltooltip">GraphQL </span></div>
        <div className="skills_gird_item">    <img src={require('./img/logo-gatsby.png')} alt="logo"></img><span className="skilltooltip">Gatsby </span></div>
        <div className="skills_gird_item">    <img src={require('./img/logo-style.png')} alt="logo"></img><span className="skilltooltip">Styled Components </span></div>
        <div className="skills_gird_item">    <img src={require('./img/logo-heroku.png')} alt="logo"></img><span className="skilltooltip">Heroku </span></div>
        <div className="skills_gird_item">    <img src={require('./img/logo-netlify.png')} alt="logo"></img><span className="skilltooltip">Netlify </span></div>

        </div>
        </div> 
      );
}

function getLogo(imgId){

}
 
export default Skills;